import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b83ff5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "telephone" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "telephone__link",
  href: "tel:02191008590"
}, [
  /*#__PURE__*/_createElementVNode("strong", null, "91008590"),
  /*#__PURE__*/_createTextVNode(" 021 ")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "17"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    fill: "#FFF",
    d: "M.999 11.839c1.157 0 2.267-.186 3.302-.528a.943.943 0 0 1 .944.222l2.036 2.035a13.934 13.934 0 0 0 6.098-6.088l-2.035-2.044a.905.905 0 0 1-.232-.935c.342-1.036.527-2.146.527-3.303a.93.93 0 0 1 .926-.926h3.238a.93.93 0 0 1 .926.926c0 8.688-7.042 15.73-15.73 15.73a.928.928 0 0 1-.925-.926v-3.238c0-.509.415-.925.925-.925z"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_button = _resolveComponent("header-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_header_button, { class: "telephone__button" }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    })
  ]))
}